<div class="modal-header">
  <h5
    class="modal-title"
    [translate]="data.titleTranslationKey"
    [translateParams]="data.titleParameters"
  ></h5>
</div>
<div class="modal-body">
  <p
    [translate]="data.messageTranslationKey"
    [translateParams]="data.messageParameters"
  ></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="onCancel()">
    {{ data.cancelLabelTranslationKey ?? 'common.actions.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="onConfirm()">
    {{ data.confirmLabelTranslationKey ?? 'common.actions.ok' | translate }}
  </button>
</div>
